module.exports = __webpack_public_path__ + "static/media/hello.2947db9d.png";